import React from 'react'
import styles from './styles.module.css'
import caretDown from '../../../images/caretDownGeneric.svg'
import infoIconRegular from './../images/circle-info-regular-full.svg'
import Tooltip from '@mui/material/Tooltip'

function MostRecentRentalPrice ({ priceRentalFilter, setRentalPriceFilter }) {
  const handleRentalPriceValueChange = event => {
    const { name, value } = event.target
    const re = /^[0-9\b]+$/
    if (value === '' || re.test(value)) {
      setRentalPriceFilter(prevState => ({
        ...prevState,
        [name]: value,
        currency: prevState.currency || 'USD'
      }))
    }
  }

  const handleRentalCurrencyChange = event => {
    const { value } = event.target
    setRentalPriceFilter(prevState => ({
      ...prevState,
      currency: value
    }))
  }

  return (
    <div className={styles.RecentRentalContainer}>
      <div className={styles.sectionTitleWithIcon}>
        <span className={styles.spanPrice}>Most recent rental list price</span>
        <Tooltip
          title='Filter by the most recent rental list price. Enter a minimum, maximum, or both to refine results.'
          arrow
          placement='top'
          slotProps={{
            popper: {
              sx: {
                '& .MuiTooltip-tooltip': {
                  maxWidth: 500,
                  fontSize: '13px',
                  padding: '8px'
                }
              }
            }
          }}
        >
          <img
            src={infoIconRegular}
            alt='Most recent rental list price info'
            width={14}
            height={14}
            className={styles.infoIcon}
          />
        </Tooltip>
      </div>
      <div className={styles.inputPriceGroup}>
        <input
          autoComplete='off'
          className={styles.inputPrice}
          placeholder='Min'
          onChange={handleRentalPriceValueChange}
          value={priceRentalFilter.minValue}
          name='minValue'
        />

        {/* Max Value Input */}
        <input
          autoComplete='off'
          className={styles.inputPrice}
          placeholder='Max'
          onChange={handleRentalPriceValueChange}
          value={priceRentalFilter.maxValue}
          name='maxValue'
        />
        <div style={{ marginRight: '32px' }}>
          <select
            className={styles.selectPrice}
            onChange={handleRentalCurrencyChange}
            value={priceRentalFilter.currency}
            name='currency'
          >
            <option value='USD'>USD</option>
            <option value='CAD'>CAD</option>
            {/* Add more currency options here */}
          </select>
          <img
            src={caretDown}
            alt='arrow'
            className={styles.customArrowPrice}
          />
        </div>
      </div>
    </div>
  )
}

export default MostRecentRentalPrice
